import { propertyLocation } from './propertyLocation';
import { buildNwsMapClickUrl } from '../utils/nwsMapClickUrl';
import { buildNwsRadarLocationUrl } from '../utils/nwsRadarUrl';

/** Re-exported from repo-root property-location.json — do not hardcode coordinates here. */
export const WEATHER_LAT = propertyLocation.latitude;
export const WEATHER_LON = propertyLocation.longitude;
export const WEATHER_LOCATION = propertyLocation.displayName;
export const WEATHER_TIMEZONE = propertyLocation.timezone;
export const NWS_ZONE = propertyLocation.nws.zone;
export const NWS_COUNTY_ZONE = propertyLocation.nws.countyZone;
export const NWS_STATE = propertyLocation.nws.state;

export const NWS_USER_AGENT = 'DailyLife/1.0 (https://github.com/codenesium/DailyLife; property-weather-page)';

/** Latest area forecast discussion from the property NWS office. */
export const NWS_AFD_URL = `https://www.weather.gov/${propertyLocation.nws.office.toLowerCase()}/afd`;

export const SPC_TEXAS_OUTLOOK_HUB = 'https://www.weather.gov/sjt/TexasSevereWeatherOutlooks';
export const SPC_TEXAS_OUTLOOK_IMAGES = [
  { label: 'Today', url: 'https://www.spc.noaa.gov/partners/outlooks/state/images/TX_swody1.png' },
  { label: 'Day 2', url: 'https://www.spc.noaa.gov/partners/outlooks/state/images/TX_swody2.png' },
  { label: 'Day 3', url: 'https://www.spc.noaa.gov/partners/outlooks/state/images/TX_swody3.png' },
] as const;

export const WPC_QPF_HUB = 'https://www.wpc.ncep.noaa.gov/qpf/day1-7.shtml';
export const WPC_QPF_API = 'https://www.wpc.ncep.noaa.gov/qpf/get_qpf_valid_times.php?fpd=multi';

/** Fallback map URLs when WPC API is unreachable from the browser (full-size GIFs). */
export const WPC_QPF_FALLBACK_IMAGES = [
  { label: '5-day total', url: 'https://www.wpc.ncep.noaa.gov/qpf/p120i.gif' },
  { label: '7-day total', url: 'https://www.wpc.ncep.noaa.gov/qpf/p168i.gif' },
] as const;

export const NWS_MAPCLICK_URL = buildNwsMapClickUrl({
  mapClickCity: propertyLocation.nws.mapClickCity,
  state: propertyLocation.nws.state,
  office: propertyLocation.nws.office,
  latitude: propertyLocation.latitude,
  longitude: propertyLocation.longitude,
});

/** Live NWS radar loop/map centered on property-location.json coordinates. */
export const NWS_RADAR_LOCATION_URL = buildNwsRadarLocationUrl(
  propertyLocation.latitude,
  propertyLocation.longitude
);
